// Both scopes are resolved against the /api/internal/designers payload: checking one filters the
// list to its members and selects every one of them, so the flags have to answer both questions.
export const SCOPE_PREDICATES = {
  following: designer => designer.following,
  top: designer => designer.topDesigner,
}

export const DESIGNER_SCOPES = Object.keys(SCOPE_PREDICATES)

// A scope with a backend flag rides on it instead of expanding to one `author[]` per member, which
// keeps a shared URL short. Only `following` has one (ListingPageController#following_ids). `top`
// has none yet (BE 86cbdgqgc), so DesignerContent expands it to its members' usernames instead -
// a `top_designers` flag would be dropped by ExtractItemsSearchOptions and return the whole catalog.
export const SCOPE_PARAMS = {
  following: 'following',
}

export const scopeMembers = (options, scope) => options
  .filter(SCOPE_PREDICATES[scope])
  .map(designer => designer.username)
